// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3SIYm","label":"Category_label__1mS70","content":"Category_content__18Q5E","header":"Category_header__GkUDC","location":"Category_location__1019R"};